//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import { BailetsBlock } from '../../ModalCopy.styles';
import { CloseVideoIcon, LogoMartins } from '@assets/svgs';
import { CWriting } from '@data/copywriting';

type BreitlingProps = {
  isClosed?: () => void;
  showImg?: boolean | string;
  showMedia?: boolean | string;
};

export const Iphone16 = ({ isClosed, showImg, showMedia }: BreitlingProps) => {
  return (
    <>
      <BailetsBlock>
        <CloseVideoIcon
          animation="closeIcon"
          color="#000"
          isActive={isClosed}
        />
        <LogoMartins
          width={70}
          height={65}
          color="rgba(0,0,0,0.5)"
          animation="mansion"
        />

        <h3>APPLE</h3>
        <span style={{ marginBottom: '25px' }}>IPHONE 16 PRO | PRO MAX</span>
        {showImg && <Image src={showImg} width={1480} height={825} alt="" />}
        {showMedia && (
          <video
            controlsList="nodownload"
            controls={true}
            playsInline
            muted
            autoPlay
            loop
          >
            <source src={showMedia} type="video/mp4" />
          </video>
        )}
        <h3 style={{ marginTop: '25px' }}>{CWriting.copyWriting[4].title1}</h3>
        <h3>{CWriting.copyWriting[4].title2}</h3>
        <br />
        <br />
        <p>
          <b>Dominate the WORLD!</b>
          <br />
          <br />
          Raise your photography skills with a state-of-the-art device right at
          your fingertips! The new Camera Control button is here to make your
          life easier!
        </p>
        <p style={{ width: '100%' }}>
          This tool is perfect for effortless exposure, depth, and vibrancy
          management.{' '}
        </p>
        <p style={{ width: '100%' }}>
          Capture stunning videos in Dolby Vision at 120 fps and enjoy the
          brilliance of 5x optical flash.
        </p>
        <p style={{ width: '100%' }}>
          Have you ever thought about unlocking your creative potential? You're
          just a step away from greatness. Transport yourself to a world of
          imagination.
        </p>
        <p style={{ width: '100%' }}>
          Your mind will be illuminated by the device's brilliance, aligning its
          mindset with yours, and creating a unique connection.
        </p>
        <p style={{ width: '100%' }}>
          It's revolutionary! Shine brightly as your own guiding light.
        </p>
        <p style={{ width: '100%' }}>
          <b>What else?</b>
        </p>
        <p style={{ width: '100%' }}>
          The iPhone 16 Pro, set to debut in late 2024, represents the latest
          remarkable chapter in Apple's story of innovation. It merges advanced
          hardware with sophisticated software. With enhancements in display
          technology, performance, camera features, and overall aesthetics, this
          device is poised to reinforce Apple's leadership in the premium
          smartphone arena—and it promises to be a true game-changer!
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Project Overview</b>
        </p>
        <p style={{ width: '100%' }}>
          We're on a mission to craft the most compelling copy for the Apple
          iPhone 16 Pro yet! The goal is to engage a premium audience of
          tech-savvy professionals, creators, and enthusiasts. We'll showcase
          the iPhone 16 Pro's cutting-edge features, superior integration into
          the Apple ecosystem, and its unparalleled potential as a tool for
          creative and professional excellence. Get ready, because this is going
          to be big!
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Target Audience</b>
        </p>
        <p style={{ width: '100%' }}>
          1- Professionals demand high performance for productivity, design, and
          on-the-go tasks. They need professional-grade tools, and they need
          them now.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          2- Creators are photographers, videographers, and artists who demand
          the best tools on the market.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          3- Tech enthusiasts are early adopters eager to experience the latest
          innovations in technology.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          4- Apple loyalists are existing customers within the Apple ecosystem
          looking for seamless device integration.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Messaging Pillars</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>1. Innovation and Performance</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Headline:</b> "Unleash Unprecedented Power."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Subhead:</b> "Powered by the all-new A18 Pro chip, the iPhone 16
          Pro delivers 20% faster performance and unparalleled efficiency."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Body:</b> "From complex multitasking to gaming with lifelike ray
          tracing, the iPhone 16 Pro is engineered to keep up with your boldest
          ambitions. Experience the next-level speed, smoother graphics, and
          smarter AI with every tap, swipe, and click."
        </p>
        <p style={{ width: '100%' }}>
          <b>2. Photography and Videography</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Headline:</b> "Capture the Extraordinary."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Subhead:</b> "The iPhone 16 Pro’s 48MP Fusion Camera lets you shoot
          like a pro."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Body:</b> "Bring your vision to life with precision tools at your
          fingertips. The new Camera Control button revolutionizes your
          photography, offering intuitive control over exposure, depth, and
          zoom. Create cinematic-quality videos with Dolby Vision at 120 fps and
          capture every detail with 5x optical zoom."
        </p>
        <p style={{ width: '100%' }}>
          <b>3. Seamless Ecosystem</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Headline:</b> "Your World, Perfectly Connected."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Subhead:</b> "Designed to work effortlessly with the Apple
          ecosystem."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Body:</b> "The iPhone 16 Pro integrates seamlessly with your Mac,
          iPad, and Vision Pro. Share files in seconds, take calls on any
          device, and charge your accessories directly from your iPhone. It’s
          all part of an ecosystem that just works."
        </p>
        <p style={{ width: '100%' }}>
          <b>4. Design and Durability</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Headline:</b> "Elegance Meets Endurance."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Subhead:</b> "Crafted from titanium, built to last."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Body:</b> "The iPhone 16 Pro’s aerospace-grade titanium frame
          redefines durability without sacrificing style. Featuring a 6.3-inch
          Super Retina XDR display with Ceramic Shield, it’s as tough as it is
          stunning. Choose from four striking finishes to match your aesthetic."
        </p>
        <p style={{ width: '100%' }}>
          <b>5. Sustainability</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Headline:</b> "A Greener Tomorrow Starts Today."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Subhead:</b> "Built with 100% recycled rare earth materials."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Body:</b> "Every iPhone 16 Pro is a step towards a more sustainable
          future. With innovative manufacturing and packaging processes, Apple
          is committed to reducing its environmental footprint."
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Campaign Slogans</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          1- "The Pro Standard. Redefined."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          2- "See it. Shoot it. Share it. Instantly."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          3- "Innovation Without Limits."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          4- "Power Meets Precision."
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Deliverables</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>1- Website Copy:</p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          1.1- Landing Page Headlines and CTAs.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          1.2- Feature Highlights with visual storytelling.
        </p>
        <p style={{ width: '100%' }}>2- Social Media Posts:</p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          2.1- Short, engaging captions paired with high-impact visuals.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          2.2- Carousel posts showcasing features like the Camera Control button
          and A18 Pro chip.
        </p>
        <p style={{ width: '100%' }}>3- Email Campaigns:</p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          3.1- Launch Announcement.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          3.2- Targeted emails for photographers, gamers, and professionals.
        </p>
        <p style={{ width: '100%' }}>4- Video Scripts:</p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          4.1- 30-second promotional ad: "Meet the iPhone 16 Pro."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          4.2- Feature walkthrough: "How the A18 Pro Chip Changes the Game."
        </p>
        <p style={{ width: '100%' }}>5- Print Ads:</p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          5.1- Minimalist designs emphasise key features and premium appeal.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Call-to-Action Examples</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          1- "Pre-order the iPhone 16 Pro today and redefine what’s possible."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          2- "Discover the future of creativity with the iPhone 16 Pro."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          3- "Experience professional-grade tools in your pocket."
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Metrics for Success</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          1- <b>Engagement:</b> Click-through rates on email campaigns and
          social media ads.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          2- <b>Conversion:</b> Pre-order and sales numbers within the first
          month.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          3- <b>Brand Sentiment:</b> Positive feedback on social media and tech
          review platforms.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          4- <b>Customer Retention:</b> Increased adoption of complementary
          Apple services and devices.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Background</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Apple is the industry leader in delivering innovative technology for
          professionals and tech aficionados. The iPhone 15 Pro was a remarkable
          success. The upcoming iPhone 16 Pro will build on that success with
          its powerful processing capabilities, improved photography features,
          and a more user-friendly interface. And it will preserve the beloved,
          classic design that has become synonymous with the brand.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Impact on Apple’s Ecosystem</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          The iPhone 16 Pro's incredible features, such as spatial photography
          and AI advancements, integrate closely with the Vision Pro and other
          Apple devices, reinforcing Apple's ecosystem strategy in a big way!
          The company has even more great features in store for us! For example,
          accessory charging via USB-C is another great step towards making the
          ecosystem compatible.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Conclusion</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          The iPhone 16 Pro showcases Apple's commitment to delivering
          professional-level tools within a smartphone design. Although some may
          find its upgrades to be modest, the device's impressive performance,
          exceptional camera features, and seamless integration within the Apple
          ecosystem make it an appealing option for both professionals and tech
          enthusiasts. This model solidifies Apple's standing in the high-end
          smartphone arena, and we eagerly anticipate their next innovations!
        </p>
      </BailetsBlock>
    </>
  );
};
